import { render } from "./EditPermissionGroup.vue?vue&type=template&id=4c3fdd2f&scoped=true&ts=true"
import script from "./EditPermissionGroup.vue?vue&type=script&lang=ts"
export * from "./EditPermissionGroup.vue?vue&type=script&lang=ts"

import "./EditPermissionGroup.vue?vue&type=style&index=0&id=4c3fdd2f&scoped=true&lang=css"

import exportComponent from "/home/dankoff_shop_admin/public_html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3fdd2f"]])

export default __exports__